module.exports = __webpack_public_path__ + "static/media/Success.5b52cdd0.svg";